// extracted by mini-css-extract-plugin
export default {"slide_item_container":"SlideItem_slide_item_container__Xu9rh"};